// ============================================================
// SALT — Cookie Consent Banner
// Located: src/components/common/CookieConsent.tsx
//
// Minimal bottom bar that appears when user hasn't made a
// cookie consent choice. Accepts or declines analytics cookies.
// Consent is stored in a cross-subdomain cookie (sl_cookie_consent).
//
// Mount this in App.tsx — it renders on all pages.
// ============================================================

import React, { useState, useEffect } from 'react';
import {
  hasConsentChoice,
  grantConsent,
  revokeConsent,
} from '../../utils/analytics';

import './CookieConsent.css';

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Small delay so it doesn't flash on page load
    const timer = setTimeout(() => {
      if (!hasConsentChoice()) {
        setVisible(true);
      }
    }, 800);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    grantConsent();
    setVisible(false);
  };

  const handleDecline = () => {
    revokeConsent();
    setVisible(false);
  };

  return (
    <div className="sl-cookie-banner" role="dialog" aria-label="Cookie consent">
      <div className="sl-cookie-banner-inner">
        <p className="sl-cookie-banner-text">
          We use cookies for authentication (required) and analytics via Google
          Analytics to understand how the platform is used. You can accept or
          decline analytics cookies.{' '}
          <a href="/legal?tab=privacy" className="sl-cookie-banner-link">
            Privacy Policy
          </a>
        </p>
        <div className="sl-cookie-banner-actions">
          <button
            type="button"
            className="sl-cookie-btn sl-cookie-btn--decline"
            onClick={handleDecline}
          >
            Decline
          </button>
          <button
            type="button"
            className="sl-cookie-btn sl-cookie-btn--accept"
            onClick={handleAccept}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;